import { ArrowOutward } from '@mui/icons-material';
import { Button, Tooltip, ButtonProps } from '@mui/material';

type LegacyEcoisButtonProps = {
  buttonText?: string;
} & Omit<ButtonProps, 'onClick'>;

function LegacyEcoisButton({ buttonText = '旧Ecois画面', ...buttonProps }: LegacyEcoisButtonProps) {
  return (
    <Tooltip
      title={
        <p>
          旧画面は2026年7月頃を目処にサポート終了予定です。
          <br />
          （詳細は日程確定次第、ご案内いたします）
          <br />
          新画面をぜひご利用くださいませ。
        </p>
      }
      placement='bottom'
    >
      <Button
        sx={{
          textTransform: 'none',
          ...buttonProps.sx,
        }}
        onClick={() => window.open('https://v1.ecois.jp/', '_blank')}
        {...buttonProps}
      >
        {buttonText}
        <ArrowOutward fontSize='small' />
      </Button>
    </Tooltip>
  );
}

export { LegacyEcoisButton };
